import { Info } from 'data/entity/Info';
import { InfoRepository } from 'data/repositories/Info';
import { Resource } from 'data/Resource';
import { EventBus } from 'services/event/bus';
import { InfoCreatedEvent, InfoDeletedEvent, InfoUpdatedEvent } from 'services/event/events';
import logger from 'services/Logging';
import { Container } from 'unstated-typescript';

export type ParkInfosState = {
  infos: Resource<Info[]>;
};

export class ParkInfosContainer extends Container<ParkInfosState> {
  constructor(
    private repository: InfoRepository,
    private parkId: string,
    private eventBus: EventBus,
  ) {
    super();

    if (!eventBus) throw new Error();

    this.eventBus.subscribe(InfoDeletedEvent.Name, (event) => {
      if (this.state.infos.data === null) return;

      const deletedEvent = event as InfoDeletedEvent;

      const newInfos = this.state.infos.data.filter((info) => info.id !== deletedEvent.infoId);
      if (newInfos.length === this.state.infos.data.length) return;

      this.setState({
        ...this.state,
        infos: Resource.success(newInfos),
      });
    });

    this.eventBus.subscribe(InfoCreatedEvent.Name, (event) => {
      const infos = this.state.infos.data;
      if (infos === null) return;

      const createdEvent = event as InfoCreatedEvent;
      if (createdEvent.parkId !== this.parkId) return;
      const createdInfo = createdEvent.info;

      const newInfos = [...infos, createdInfo];
      this.setState({
        ...this.state,
        infos: Resource.success(newInfos),
      });
    });

    this.eventBus.subscribe(InfoUpdatedEvent.Name, (event) => {
      const infos = this.state.infos.data;
      if (infos === null) return;

      const updatedEvent = event as InfoUpdatedEvent;
      const updatedInfo = updatedEvent.info;

      const newInfos = infos.map((info) => (info.id === updatedInfo.id ? updatedInfo : info));
      this.setState({
        ...this.state,
        infos: Resource.success(newInfos),
      });
    });
  }

  state = {
    infos: Resource.idle<Info[]>(),
  };

  async load() {
    this.setState({
      ...this.state,
      infos: Resource.loading(),
    });

    try {
      const infos = await this.repository.getParkInfos(this.parkId);

      this.setState({
        ...this.state,
        infos: Resource.success(infos),
      });
    } catch (e) {
      logger.logError(e);

      this.setState({
        ...this.state,
        infos: Resource.error('Informationen konnten nicht geladen werden.'),
      });
    }
  }
}
